import { schema } from 'normalizr';

export const workItemSchema = new schema.Entity('workItems', {}, { idAttribute: 'WorkItemId' });

export const workItemListSchema = [workItemSchema];
